<template>
  <layout :title="job.title">
    <div class="max-w-4xl px-5 mx-auto lg:px-0 pb-12 mt-10">
      <a
        href="https://app.sesametime.com/jobs/youverse"
        class="inline-flex items-center mb-6 font-mono text-sm font-bold cursor-pointer text-primary-color"
      >
        <svg
          class="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          ></path>
        </svg>
        back to careers
      </a>
      <h1 class="flex flex-col leading-none">
        <span class="break-words text-3xl font-extrabold">{{ job.title }}</span>
        <span class="mt-2 text-gray-600" v-if="job.created_at"
          >Created at {{ job.created_at | formatDate }}</span
        >
      </h1>
      <div class="md:flex flex-row items-start mt-10 md:space-x-6">
        <div
          class="prose prose-lg lg:prose-xl p-4 bg-white shadow-allArround rounded-xl md:w-3/4"
          v-html="job.body"
        >
          {{ job.body }}
        </div>
        <div
          class="flex-1 p-4 bg-white shadow-allArround rounded-xl space-y-2 md:mt-0 mt-5 sticky top-20"
        >
          <div class="flex flex-col">
            <span>Job position</span>
            <span class="text-gray-600 text-sm">{{ job.category }}</span>
          </div>
          <div class="flex flex-col">
            <span>Contract type</span>
            <span class="text-gray-600 text-sm">{{ job.contract_type }}</span>
          </div>
          <div class="flex flex-col">
            <span>Location</span>
            <span class="text-gray-600 text-sm">{{ job.location }}</span>
          </div>
          <div
            class="flex flex-col"
            v-if="this.$page.props.job.experience != null"
          >
            <span>Experience</span>
            <span class="text-gray-600 text-sm">{{ job.experience }}</span>
          </div>
          <div
            class="flex flex-col"
            v-if="this.$page.props.job.open_until != null"
          >
            <span>Open until</span>
            <span class="text-gray-600 text-sm">{{
              job.open_until | formatDate
            }}</span>
          </div>
          <div class="pt-2">
            <button
              v-if="canApply"
              class="btn-primary w-full"
              @click="showFormApply = true"
            >
              Apply
            </button>
            <button
              v-else
              class="btn-no-color w-full bg-gray-200 text-gray-700"
              style="cursor: unset"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
    <modalForm :show="showFormApply" @closeModal="showFormApply = false">
      <form
        role="form"
        @submit.prevent="submitApply"
        method="POST"
        enctype="multipart/form-data"
      >
        <div>
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Email address</label
          >
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="email"
              type="email"
              name="email"
              v-model="form.email"
              required
              class="w-full"
              autofocus
            />
          </div>

          <div class="error" v-if="errors.email">{{ errors.email }}</div>
        </div>

        <div class="mt-6">
          <label
            for="message"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Message
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <textarea
              id="message"
              type="text"
              name="message"
              v-model="form.message"
              required
              class="w-full"
              rows="2"
            />
          </div>
          <div class="error" v-if="errors.message">
            {{ errors.message }}
          </div>
        </div>

        <div class="mt-6">
          <label
            for="cv"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            CV in PDF
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="cv"
              type="file"
              name="message"
              accept="application/pdf"
              @change="assignCvFile"
              required
              class="w-full"
            />
          </div>
          <div class="error" v-if="errors.cv">
            {{ errors.cv }}
          </div>
        </div>

        <div class="mt-6">
          <span class="block w-full rounded-md shadow-sm">
            <button type="submit" class="btn-primary w-full">Apply</button>
          </span>
        </div>
      </form>
    </modalForm>
    {{ errors.email }}
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
import { LocationMarkerIcon, BriefcaseIcon } from "@vue-hero-icons/outline";
import modalForm from "../Components/modal.vue";
export default {
  props: {
    errors: Object,
  },
  components: { layout, LocationMarkerIcon, BriefcaseIcon, modalForm },
  data() {
    return {
      job: this.$page.props.job,
      showFormApply: false,
      form: {
        email: null,
        message: null,
        cv: null,
        jobName: this.$page.props.job.title,
      },
      canApply:
        this.$page.props.job.open_until == null
          ? true
          : new Date().getDate() <=
            new Date(this.$page.props.job.open_until).getDate(),
    };
  },
  methods: {
    submitApply() {
      this.$inertia.post("/apply-job", this.form, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null)
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
            });
          this.showFormApply = false;
          this.form.email = null;
          this.form.message = null;
          this.form.cv = null;
        },
      });
    },
    assignCvFile(event) {
      this.form.cv = event.target.files[0];
    },
  },
};
</script>

<style>
.prose {
  color: #374151;
}

.prose [class~="lead"] {
  color: #4b5563;
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.prose a {
  color: #111827;
  text-decoration: underline;
  font-weight: 600;
}

.prose strong {
  color: #111827;
  font-weight: 600;
}

.prose ol {
  counter-reset: list-counter;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}

.prose ol > li {
  position: relative;
  counter-increment: list-counter;
  padding-left: 1.75em;
}

.prose ol > li:before {
  content: counter(list-counter) ".";
  position: absolute;
  font-weight: 600;
  color: #6b7280;
  left: 0;
}

.prose ul > li {
  position: relative;
  padding-left: 1.75em;
}

.prose ul > li:before {
  content: "";
  position: absolute;
  background-color: black;
  border-radius: 50%;
  width: 0.375em;
  height: 0.375em;
  top: 0.6875em;
  left: 0.25em;
}

.prose hr {
  border-color: #e5e7eb;
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}

.prose blockquote {
  font-weight: 600;
  font-style: italic;
  color: #111827;
  border-left-width: 0.25rem;
  border-left-color: #e5e7eb;
  quotes: "\201C""\201D""\2018""\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}

.prose blockquote p:first-of-type:before {
  content: open-quote;
}

.prose blockquote p:last-of-type:after {
  content: close-quote;
}

.prose h1 {
  color: #111827;
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}

.prose h2 {
  color: #111827;
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}

.prose h3 {
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}

.prose h3,
.prose h4 {
  color: #111827;
  font-weight: 600;
}

.prose h4 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}

.prose figure figcaption {
  color: #6b7280;
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}

.prose code {
  color: #111827;
  font-weight: 600;
  font-size: 0.875em;
}

.prose code:after,
.prose code:before {
  content: "`";
}

.prose a code {
  color: #111827;
}

.prose pre {
  color: #e5e7eb;
  background-color: #1f2937;
  overflow-x: auto;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding: 0.8571429em 1.1428571em;
}

.prose pre code {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: 600;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

.prose pre code:after,
.prose pre code:before {
  content: "";
}

.prose table {
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}

.prose thead {
  color: #111827;
  font-weight: 600;
  border-bottom-width: 1px;
  border-bottom-color: #d1d5db;
}

.prose thead th {
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

.prose tbody tr {
  border-bottom-width: 1px;
  border-bottom-color: #e5e7eb;
}

.prose tbody tr:last-child {
  border-bottom-width: 0;
}

.prose tbody td {
  vertical-align: top;
  padding: 0.5714286em;
}

.prose {
  font-size: 1rem;
  line-height: 1.75;
}

.prose p {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}

.prose figure,
.prose img,
.prose video {
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose figure > * {
  margin-top: 0;
  margin-bottom: 0;
}

.prose h2 code {
  font-size: 0.875em;
}

.prose h3 code {
  font-size: 0.9em;
}

.prose ul {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}

.prose li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.prose > ul > li p {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.prose > ul > li > :first-child {
  margin-top: 1.25em;
}

.prose > ul > li > :last-child {
  margin-bottom: 1.25em;
}

.prose > ol > li > :first-child {
  margin-top: 1.25em;
}

.prose > ol > li > :last-child {
  margin-bottom: 1.25em;
}

.prose ol ol,
.prose ol ul,
.prose ul ol,
.prose ul ul {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.prose h2 + *,
.prose h3 + *,
.prose h4 + *,
.prose hr + * {
  margin-top: 0;
}

.prose thead th:first-child {
  padding-left: 0;
}

.prose thead th:last-child {
  padding-right: 0;
}

.prose tbody td:first-child {
  padding-left: 0;
}

.prose tbody td:last-child {
  padding-right: 0;
}

.prose > :first-child {
  margin-top: 0;
}

.prose > :last-child {
  margin-bottom: 0;
}

.prose-xl {
  font-size: 1.25rem;
  line-height: 1.8;
}

.prose-xl p {
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.prose-xl [class~="lead"] {
  font-size: 1.2em;
  line-height: 1.5;
  margin-top: 1em;
  margin-bottom: 1em;
}

.prose-xl blockquote {
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1.0666667em;
}

.prose-xl h1 {
  font-size: 2.8em;
  margin-top: 0;
  margin-bottom: 0.8571429em;
  line-height: 1;
}

.prose-xl h2 {
  font-size: 1.8em;
  margin-top: 1.5555556em;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}

.prose-xl h3 {
  font-size: 1.5em;
  margin-top: 1.6em;
  margin-bottom: 0.6666667em;
  line-height: 1.3333333;
}

.prose-xl h4 {
  margin-top: 1.8em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}

.prose-xl figure,
.prose-xl img,
.prose-xl video {
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose-xl figure > * {
  margin-top: 0;
  margin-bottom: 0;
}

.prose-xl figure figcaption {
  font-size: 0.9em;
  line-height: 1.5555556;
  margin-top: 1em;
}

.prose-xl code {
  font-size: 0.9em;
}

.prose-xl h2 code {
  font-size: 0.8611111em;
}

.prose-xl h3 code,
.prose-xl pre {
  font-size: 0.9em;
}

.prose-xl pre {
  line-height: 1.7777778;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.5rem;
  padding: 1.1111111em 1.3333333em;
}

.prose-xl ol,
.prose-xl ul {
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.prose-xl li {
  margin-top: 0.6em;
  margin-bottom: 0.6em;
}

.prose-xl ol > li {
  padding-left: 1.8em;
}

.prose-xl ol > li:before {
  left: 0;
}

.prose-xl ul > li {
  padding-left: 1.8em;
}

.prose-xl ul > li:before {
  width: 0.35em;
  height: 0.35em;
  top: 0.725em;
  left: 0.25em;
}

.prose-xl > ul > li p {
  margin-top: 0.8em;
  margin-bottom: 0.8em;
}

.prose-xl > ul > li > :first-child {
  margin-top: 1.2em;
}

.prose-xl > ul > li > :last-child {
  margin-bottom: 1.2em;
}

.prose-xl > ol > li > :first-child {
  margin-top: 1.2em;
}

.prose-xl > ol > li > :last-child {
  margin-bottom: 1.2em;
}

.prose-xl ol ol,
.prose-xl ol ul,
.prose-xl ul ol,
.prose-xl ul ul {
  margin-top: 0.8em;
  margin-bottom: 0.8em;
}

.prose-xl hr {
  margin-top: 2.8em;
  margin-bottom: 2.8em;
}

.prose-xl h2 + *,
.prose-xl h3 + *,
.prose-xl h4 + *,
.prose-xl hr + * {
  margin-top: 0;
}

.prose-xl table {
  font-size: 0.9em;
  line-height: 1.5555556;
}

.prose-xl thead th {
  padding-right: 0.6666667em;
  padding-bottom: 0.8888889em;
  padding-left: 0.6666667em;
}

.prose-xl thead th:first-child {
  padding-left: 0;
}

.prose-xl thead th:last-child {
  padding-right: 0;
}

.prose-xl tbody td {
  padding: 0.8888889em 0.6666667em;
}

.prose-xl tbody td:first-child {
  padding-left: 0;
}

.prose-xl tbody td:last-child {
  padding-right: 0;
}

.prose-xl > :first-child {
  margin-top: 0;
}

.prose-xl > :last-child {
  margin-bottom: 0;
}

@media (min-width: 1024px) {
  .lg\:prose-2xl {
    font-size: 1.5rem;
    line-height: 1.6666667;
  }

  .lg\:prose-2xl p {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\:prose-2xl [class~="lead"] {
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }

  .lg\:prose-2xl blockquote {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }

  .lg\:prose-2xl h1 {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }

  .lg\:prose-2xl h2 {
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }

  .lg\:prose-2xl h3 {
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }

  .lg\:prose-2xl h4 {
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .lg\:prose-2xl figure,
  .lg\:prose-2xl img,
  .lg\:prose-2xl video {
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\:prose-2xl figure > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\:prose-2xl figure figcaption {
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }

  .lg\:prose-2xl code {
    font-size: 0.8333333em;
  }

  .lg\:prose-2xl h2 code {
    font-size: 0.875em;
  }

  .lg\:prose-2xl h3 code {
    font-size: 0.8888889em;
  }

  .lg\:prose-2xl pre {
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding: 1.2em 1.6em;
  }

  .lg\:prose-2xl ol,
  .lg\:prose-2xl ul {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\:prose-2xl li {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .lg\:prose-2xl ol > li {
    padding-left: 1.6666667em;
  }

  .lg\:prose-2xl ol > li:before {
    left: 0;
  }

  .lg\:prose-2xl ul > li {
    padding-left: 1.6666667em;
  }

  .lg\:prose-2xl ul > li:before {
    width: 0.3333333em;
    height: 0.3333333em;
    top: 0.66667em;
    left: 0.25em;
  }

  .lg\:prose-2xl > ul > li p {
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }

  .lg\:prose-2xl > ul > li > :first-child {
    margin-top: 1.3333333em;
  }

  .lg\:prose-2xl > ul > li > :last-child {
    margin-bottom: 1.3333333em;
  }

  .lg\:prose-2xl > ol > li > :first-child {
    margin-top: 1.3333333em;
  }

  .lg\:prose-2xl > ol > li > :last-child {
    margin-bottom: 1.3333333em;
  }

  .lg\:prose-2xl ol ol,
  .lg\:prose-2xl ol ul,
  .lg\:prose-2xl ul ol,
  .lg\:prose-2xl ul ul {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .lg\:prose-2xl hr {
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .lg\:prose-2xl h2 + *,
  .lg\:prose-2xl h3 + *,
  .lg\:prose-2xl h4 + *,
  .lg\:prose-2xl hr + * {
    margin-top: 0;
  }

  .lg\:prose-2xl table {
    font-size: 0.8333333em;
    line-height: 1.4;
  }

  .lg\:prose-2xl thead th {
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .lg\:prose-2xl thead th:first-child {
    padding-left: 0;
  }

  .lg\:prose-2xl thead th:last-child {
    padding-right: 0;
  }

  .lg\:prose-2xl tbody td {
    padding: 0.8em 0.6em;
  }

  .lg\:prose-2xl tbody td:first-child {
    padding-left: 0;
  }

  .lg\:prose-2xl tbody td:last-child {
    padding-right: 0;
  }

  .lg\:prose-2xl > :first-child {
    margin-top: 0;
  }

  .lg\:prose-2xl > :last-child {
    margin-bottom: 0;
  }
}
</style>